<wp-custom-action
    *ngFor="let action of actions"
    [workPackage]="workPackage"
    [action]="action"
    class="custom-action">
</wp-custom-action>
